<template>
  <a-modal
    class="info-dialog"
    title="下载数据"
    width="1000px"
    v-model:visible="visible"
    :footer="false">
    <a-form class="info-dialog-form" ref="form" :rules="rules" :model="form">
      <a-form-item label="下载原因" name="createNote">
        <a-input v-model:value="form.createNote" autocomplete="off"></a-input>
      </a-form-item>
    </a-form>
    <div class="ctrl-wrap">
      <a-button type="primary" @click="submit">下载</a-button>
    </div>
  </a-modal>
</template>
<script>
import { mapState } from 'vuex'
import { addDownloadRecord } from '@/api/dataDownload'
export default {
  props: {
    currentItem: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      visible: false,
      form: {
        createNote: ''
      },
      rules: {
        createNote: [
          { required: true, message: '请填写下载原因', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapState(['appConfig', 'userInfo'])
  },
  methods: {
    open () {
      this.visible = true
      this.$nextTick(() => {
        this.form.createNote = ''
      })
    },
    submit () {
      this.$refs.form.validate().then(() => {
        const params = {
          pakageRecordId: this.currentItem.id,
          createNote: this.form.createNote,
          createUserId: this.userInfo.userId
        }
        addDownloadRecord(params).then(res => {
          const url = this.appConfig.baseImgUrl + this.currentItem.zipLocation
          const aTag = document.createElement('a')
          aTag.href = url
          aTag.download = this.currentItem.zipLocation
          aTag.click()
          this.$message.success('开始下载')
          this.visible = false
        }).catch(err => {
          this.$message.error(err.response.data.message)
        })
      })
    }
  }
}
</script>
<style lang="less">
.info-dialog {
  .info-dialog-form {
    display: flex; flex-wrap: wrap;
    .ant-form-item {
      margin: 0 0 10px;
      width: 50%;
    }
  }
  .ctrl-wrap {
    text-align: right;
  }
}
</style>
